import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["label", "hasLegend", "openButtonVariant", "onChange", "onToggleLegend"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { ButtonV2 as Button } from '@/components/Button';
import RevealPill, { PillSwitch } from '@/components/Editor/Form/fields/RevealPill';
import LegendPosition from '@/components/Editor/Form/fields/ChartJsLegendPosition';
import TextInputs from '@/components/Editor/Form/fields/TextInputs';
import { TemplateSection } from '@/components/Editor/Form/fields/Template';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const WidgetEditFormLegend = _ref => {
  let {
    label = 'Legend',
    hasLegend,
    openButtonVariant,
    onChange,
    onToggleLegend
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  const [open, setOpen] = React.useState(false);
  return /*#__PURE__*/_jsx(RevealPill, {
    label: label,
    open: open,
    disableOpen: !hasLegend,
    openButtonVariant: openButtonVariant,
    activeState: /*#__PURE__*/_jsx(PillSwitch, {
      checked: hasLegend,
      onChange: checked => {
        if (typeof onToggleLegend === 'function') {
          onToggleLegend(checked);
        } else {
          onChange({
            hasLegend: checked
          });
        }
      }
    }),
    onOpenChange: setOpen,
    children: /*#__PURE__*/_jsx(LegendFields, _objectSpread({
      hasLegend: hasLegend,
      onOpenChange: setOpen,
      onChange: onChange
    }, props))
  });
};

export const LegendFields = _ref2 => {
  let {
    nameSpace,
    templateLabel = 'Legend Format',
    editSelectionsLabel = 'Edit Legend Selections',
    caption = '',
    hasLegend,
    hasLegendInputs = false,
    hasTemplate = false,
    hasCaption = true,
    hasLegendPosition = true,
    legendPosition,
    legendsCount = 0,
    legends = [],
    template,
    exampleLabel,
    customFields,
    onChange,
    onChangeTemplate,
    onEditSelections,
    onOpenChange
  } = _ref2;
  const legendPositionId = `${nameSpace}-legend-position`;
  const textFieldsId = `${nameSpace}-legend-text-fields`;
  const templateFieldId = `${nameSpace}-legend-template`;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [customFields, hasCaption ? /*#__PURE__*/_jsx("p", {
      className: styles.description,
      children: caption
    }) : /*#__PURE__*/_jsx(_Fragment, {}), hasLegend && hasLegendPosition ? /*#__PURE__*/_jsx(LegendPosition, {
      elementId: legendPositionId,
      defaultValue: legendPosition,
      onChange: position => onChange({
        legendPosition: position
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {}), hasLegendInputs && hasLegend ? /*#__PURE__*/_jsx(TextInputs, {
      nameSpace: textFieldsId,
      label: "Legends",
      caption: "Add custom text in the legend for each segment.",
      inputPlaceholder: "Legend text",
      inputValues: legends,
      inputsCount: legendsCount,
      onChange: values => {
        onChange({
          legends: values
        });
      }
    }, textFieldsId) : /*#__PURE__*/_jsx(_Fragment, {}), exampleLabel && hasTemplate && onChangeTemplate ? /*#__PURE__*/_jsx(TemplateSection, {
      id: templateFieldId,
      label: templateLabel,
      caption: "Default formatting. Can be overwritten by other formatting settings.",
      exampleValue: exampleLabel,
      template: template,
      onChange: onChangeTemplate
    }) : null, onEditSelections ? /*#__PURE__*/_jsx(Button, {
      type: "button",
      variant: "secondary",
      onClick: () => {
        onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(false); // hide the pill

        onEditSelections();
      },
      children: editSelectionsLabel
    }) : /*#__PURE__*/_jsx(_Fragment, {})]
  });
};
export default WidgetEditFormLegend;